var React = require('react');

function IconDeleteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.07142857,19.8888889 C6.07142857,21.05 7.03571429,22 8.21428571,22 L16.7857143,22 C17.9642857,22 18.9285714,21.05 18.9285714,19.8888889 L18.9285714,7.22222222 L6.07142857,7.22222222 L6.07142857,19.8888889 Z M20,4.05555556 L16.25,4.05555556 L15.1785714,3 L9.82142857,3 L8.75,4.05555556 L5,4.05555556 L5,6.16666667 L20,6.16666667 L20,4.05555556 Z"}));
}

IconDeleteInline.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = IconDeleteInline;

IconDeleteInline.default = IconDeleteInline;
